import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useSunglassesProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import '@grandvisionhq/state';
import '../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../operations/queries/get-accessories-by-slug.js';
import '../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../operations/queries/get-frames-by-slug.js';
import '../../../operations/queries/get-solutions-by-slug.js';
import '../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '../../../types/product.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import { VariantSelectorTree } from '../components/VariantSelectorTree/VariantSelectorTree.js';
import { useEcommFacetContext } from '../context/EcommFacetContext.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { SunglassesCTA } from './components/SunglassesCTA/SunglassesCTA.js';
import { SunglassesPriceSection } from './components/SunglassesPriceSection/SunglassesPriceSection.js';
import { SunglassesRxableSelectContainer } from './components/SunglassesRxableSelect/SunglassesRxableSelectContainer.js';
import { useSunglassesEcommContext } from './context/SunglassesEcommContext.js';

const SunglassesEcommContent = ({ className , ctaRef  })=>{
    const { activeVariant: { displayName , sku: activeSku , isExcludedFromCheckout  } , product ,  } = useSunglassesProductData();
    const { isValid , setNotificationType  } = useEcommFacetContext();
    const triggerAlertMessage = ()=>setNotificationType('error')
    ;
    const { handleConfiguratorClose , isConfiguratorOpen , shouldOpenConfigurator  } = useSunglassesEcommContext();
    const { isOfferedWithPrescriptions  } = product;
    const { Slots  } = useProductDetailSlots();
    return /*#__PURE__*/ React.createElement("section", {
        "aria-label": displayName,
        className: classnames('sunglasses-ecomm-content', className)
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        className: "sunglasses-ecomm-content__tag"
    }), /*#__PURE__*/ React.createElement(SunglassesPriceSection, null), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(VariantSelectorTree, null), isOfferedWithPrescriptions && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SunglassesRxableSelectContainer, null), /*#__PURE__*/ React.createElement(Hr, null)), /*#__PURE__*/ React.createElement("div", {
        className: "sunglasses-ecomm-content__column"
    }, Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        isExcludedFromCheckout: isExcludedFromCheckout,
        deliveryItems: [
            {
                sku: activeSku,
                quantity: 1
            }
        ],
        hasRxLens: shouldOpenConfigurator,
        className: "sunglasses-ecomm-content__delivery-indicator"
    }) : null, /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, /*#__PURE__*/ React.createElement(SunglassesCTA, null)), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, {
        sku: activeSku,
        onInvalidClick: !isValid ? triggerAlertMessage : undefined
    }) : null), Slots.Configurator && /*#__PURE__*/ React.createElement(Slots.Configurator, {
        id: "rxSun",
        onModalClose: handleConfiguratorClose,
        isOpen: isConfiguratorOpen
    }));
};

export { SunglassesEcommContent };
//# sourceMappingURL=SunglassesEcommContent.js.map
